import { render } from "./PostalCodeDrawer.vue?vue&type=template&id=9bcf10e6&scoped=true"
import script from "./PostalCodeDrawer.vue?vue&type=script&lang=js"
export * from "./PostalCodeDrawer.vue?vue&type=script&lang=js"

import "./PostalCodeDrawer.vue?vue&type=style&index=0&id=9bcf10e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bcf10e6"]])

export default __exports__